import React from 'react'
import { withIcon } from '../../withIcon'

function SearchTextIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.375 6C3.375 5.65482 3.65482 5.375 4 5.375H20C20.3452 5.375 20.625 5.65482 20.625 6C20.625 6.34518 20.3452 6.625 20 6.625H4C3.65482 6.625 3.375 6.34518 3.375 6ZM15 11.625C13.136 11.625 11.625 13.136 11.625 15C11.625 16.864 13.136 18.375 15 18.375C16.864 18.375 18.375 16.864 18.375 15C18.375 13.136 16.864 11.625 15 11.625ZM10.375 15C10.375 12.4457 12.4457 10.375 15 10.375C17.5543 10.375 19.625 12.4457 19.625 15C19.625 16.0914 19.247 17.0945 18.6147 17.8855C18.7346 17.9078 18.8492 17.9653 18.9419 18.0581L21.4419 20.5581C21.686 20.8021 21.686 21.1979 21.4419 21.4419C21.1979 21.686 20.8021 21.686 20.5581 21.4419L18.0581 18.9419C17.9653 18.8492 17.9078 18.7346 17.8855 18.6147C17.0945 19.247 16.0914 19.625 15 19.625C12.4457 19.625 10.375 17.5543 10.375 15ZM3.375 12C3.375 11.6548 3.65482 11.375 4 11.375H8C8.34518 11.375 8.625 11.6548 8.625 12C8.625 12.3452 8.34518 12.625 8 12.625H4C3.65482 12.625 3.375 12.3452 3.375 12ZM3.375 18C3.375 17.6548 3.65482 17.375 4 17.375H8C8.34518 17.375 8.625 17.6548 8.625 18C8.625 18.3452 8.34518 18.625 8 18.625H4C3.65482 18.625 3.375 18.3452 3.375 18Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SearchTextIcon)
